import { FC, SVGProps } from 'react'

const DataAvaibilityIcon: FC<SVGProps<SVGSVGElement>> = svgProps => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...svgProps}
  >
    <path
      d="M6.86071 4.76257C0.787546 4.76257 0.877544 2.63144 0.787389 2.81151C0.697233 2.99158 0.607422 5.51301 0.607422 5.51301C0.607422 5.51301 0.78739 8.02435 6.70062 8.02435C13.3976 8.02435 13.3943 5.66307 13.3943 5.66307C13.3943 5.66307 13.3641 3.07164 13.2542 2.81151C13.1443 2.55138 13.35 4.76257 6.86071 4.76257Z"
      fill="currentColor"
    />
    <path
      d="M6.86071 8.63598C0.787546 8.63598 0.877544 6.50484 0.787389 6.68491C0.697233 6.86499 0.607422 9.38641 0.607422 9.38641C0.607422 9.38641 0.78739 11.8978 6.70062 11.8978C13.3976 11.8978 13.3943 9.53647 13.3943 9.53647C13.3943 9.53647 13.3641 6.94504 13.2542 6.68491C13.1443 6.42479 13.35 8.63598 6.86071 8.63598Z"
      fill="currentColor"
    />
    <path
      d="M6.86071 12.7382C0.787546 12.7382 0.877544 10.6071 0.787389 10.7872C0.697233 10.9672 0.607422 13.4887 0.607422 13.4887C0.607422 13.4887 0.78739 16 6.70062 16C13.3976 16 13.3943 13.6387 13.3943 13.6387C13.3943 13.6387 13.3641 11.0473 13.2542 10.7872C13.1443 10.527 13.35 12.7382 6.86071 12.7382Z"
      fill="currentColor"
    />
    <path
      d="M13.2343 2.04111C13.2343 3.16839 10.448 4.08223 7.01092 4.08223C3.57383 4.08223 0.78752 3.16839 0.78752 2.04111C0.78752 0.913838 3.57383 0 7.01092 0C10.448 0 13.2343 0.913838 13.2343 2.04111Z"
      fill="currentColor"
    />
  </svg>
)

export default DataAvaibilityIcon
